import React from 'react'

import { CreatableInput } from '@/components/forms/CreatableInput'
import { FormField } from '@/components/forms/FormField'

import './VoipCustomerSearch.scss'

export const VoipCustomerSearch = ({ handleUpdateFilters, filters }) => {
  const handleChange = (nameKey, newValues) => {
    const values = Array.isArray(newValues) ? newValues : [newValues]
    const uniqueValues = [...new Map(values.map((item) => [item.value, item])).values()]
    if (handleUpdateFilters) {
      handleUpdateFilters('voipCustomerIds', uniqueValues)
    }
  }

  return (
    <FormField data-testid="voip-customer-id-filter">
      <label data-testid="voip-customer-id-label">Customer ID</label>
      <div className="voip-customer-id-search-container medium-gap">
        <CreatableInput
          placeholder="Enter Customer ID"
          value={filters.voipCustomerIds}
          handleUpdateFilters={handleChange}
        />
      </div>
    </FormField>
  )
}
